import { FC } from 'react';
interface Props {
  width?: string;
  height?: string;
}

const SecondComplete: FC<Props> = ({ width = '38', height = '48' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 38 48" fill="none">
      <path
        d="M7.4592 1.57523C9.35059 -0.436336 12.5148 -0.53447 14.5266 1.35648C16.5382 3.24797 16.6356 6.41206 14.7444 8.42386C9.591 13.9051 8.39887 22.3186 12.3489 29.1602C16.2769 35.9636 24.0936 39.1404 31.383 37.4815C34.0752 36.869 36.7543 38.5541 37.3674 41.2461C37.9801 43.9386 36.2941 46.6176 33.6018 47.2305C22.1577 49.8351 9.87093 44.868 3.68869 34.1602C-2.52781 23.3929 -0.632013 10.1814 7.4592 1.57523ZM13.842 2.085C12.2328 0.572433 9.70098 0.650634 8.18772 2.2598C0.389983 10.5538 -1.43472 23.2858 4.5549 33.6602L4.83811 34.1397C10.881 44.125 22.5233 48.7269 33.3801 46.2559C35.534 45.7655 36.8829 43.6216 36.3928 41.4678C35.9023 39.3145 33.7585 37.9661 31.6047 38.4561C24.0196 40.1823 15.8944 36.9568 11.6809 29.9942L11.4826 29.6602C7.30641 22.4266 8.56842 13.5334 14.0158 7.73929C15.5288 6.12987 15.4511 3.59816 13.842 2.085Z"
        fill="#F7F3F0"
      />
      <path
        d="M11.4828 29.6599C7.30651 22.4263 8.56815 13.5342 14.0155 7.74009C15.5287 6.13071 15.4511 3.59922 13.842 2.08596C12.2326 0.572819 9.70111 0.650407 8.18785 2.25952C0.389822 10.5535 -1.43513 23.2853 4.55462 33.6599C10.5112 43.9771 22.3505 48.7666 33.3797 46.2563C35.5337 45.766 36.8826 43.6227 36.3925 41.4688C35.9023 39.315 33.7589 37.9661 31.605 38.456C23.8994 40.2099 15.6361 36.8536 11.4828 29.6599Z"
        fill="#FCB815"
      />
      <path
        d="M8.18797 2.25966C9.70123 0.650549 12.2329 0.572692 13.8423 2.08583C15.4514 3.59909 15.5292 6.13076 14.0161 7.74013C8.56874 13.5342 7.30658 22.4264 11.4829 29.66C12.6751 31.725 14.2081 33.4715 15.9673 34.8739L9.59226 39.9481C7.65047 38.167 5.94297 36.0637 4.55515 33.66C-1.43453 23.2856 0.390187 10.5536 8.18797 2.25966Z"
        fill="#FFD879"
      />
      <path
        d="M24.3225 44.5795C21.8178 44.4214 15.7194 43.0245 10.9298 38.6708C8.14471 36.1391 6.28657 33.1827 5.13427 30.7129C4.95934 30.3376 5.12145 29.8913 5.49672 29.7162C5.87192 29.5413 6.31822 29.7036 6.49344 30.0787C7.58275 32.4134 9.33316 35.1925 11.9379 37.5604C16.414 41.6293 22.1584 42.9397 24.4169 43.0823C24.8302 43.1084 25.1443 43.4647 25.1182 43.8781C25.0922 44.2914 24.7359 44.6055 24.3225 44.5795Z"
        fill="white"
      />
      <circle cx="10.7998" cy="5.20947" r="4.5" fill="#FFECBF" />
    </svg>
  );
};

export default SecondComplete;
